var _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 150,
    cx: 250,
    cy: 250
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "like_svg__particleLayer"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#8CE8C3",
    cx: 130,
    cy: 126.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8CE8C3",
    cx: 411,
    cy: 313.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91D2FA",
    cx: 279,
    cy: 86.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91D2FA",
    cx: 155,
    cy: 390.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC8EF5",
    cx: 89,
    cy: 292.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BDFBA",
    cx: 414,
    cy: 282.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BDFBA",
    cx: 115,
    cy: 149.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FC7FA",
    cx: 250,
    cy: 80.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FC7FA",
    cx: 78,
    cy: 261.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#96D8E9",
    cx: 182,
    cy: 402.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC8EF5",
    cx: 401.5,
    cy: 166,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB92D0",
    cx: 379,
    cy: 141.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB92D0",
    cx: 327,
    cy: 397.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD99B8",
    cx: 296,
    cy: 392.5,
    r: 10.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.256 320.183l-14.084-12.89a672.392 672.392 0 01-49.42-50.257q-21.252-24.23-21.252-51.453 0-21.722 14.686-36.408t36.167-14.675a54.232 54.232 0 0124.114 5.73 56.592 56.592 0 0120.53 17.665q9.552-11.935 20.771-17.665a51.77 51.77 0 0123.876-5.73q21.487 0 36.167 14.68 14.68 14.68 14.689 36.403 0 27.217-21.252 51.57a636.412 636.412 0 01-49.655 50.376l-13.849 12.654a15.578 15.578 0 01-21.487 0z"
  })));
}
export default SvgLike;